export type ContactIcon =
  | 'telegram'
  | 'instagram'
  | 'email'
  | 'phone'
  | 'discord'
  | 'youtube'
  | 'x'
  | 'github'
  | 'globe'
  | 'link';

export type ContactCategory = 'social' | 'support' | 'business' | 'other';

export interface ContactLink {
  id: string;
  label: string;
  url: string;
  value: string;
  icon: ContactIcon;
  category: ContactCategory;
  sort_order: number;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export const CATEGORY_LABELS: Record<ContactCategory, string> = {
  social: 'شبکه‌های اجتماعی',
  support: 'پشتیبانی و ارتباط',
  business: 'تجاری و اداری',
  other: 'سایر موارد',
};
